module.exports = __webpack_public_path__ + "../static/img/server.c1588f43.png";